import classNames from 'classnames';
import React from 'react';

import './Empty.scss'
import Col from '../Col';
import Row from '../Row';

const Empty = ({ cta, direction, headline, strapline, image, searchIsActive }) => (
  <div
    className={
      classNames(
        'empty',
        {
          [`empty--${direction}`]: direction
        }
      )
    }
  >
    <Row>
      <Col
        xs="12"
        md={direction === 'ttb' ? 12 : 5 }
      >
        <div className="empty__headline">{searchIsActive ? "Your search returned no results" : headline }</div>
        <div className="empty__strapline">{searchIsActive ? "Consider refining your search." : strapline }</div>
        {searchIsActive ? (<div></div>) : (<div className="empty__cta">{cta}</div>) }
      </Col>
      <Col
        xs="12"
        md={direction === 'ttb' ? 12 : 6 }
        mdOffset={direction === 'ttb' ? null : 1}
      >
        <div className="empty__image">{image}</div>
      </Col>
    </Row>
  </div>
);

export default Empty;
